import { type IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { type customFontAwesomeIcons } from "./listOfIcons";

type CustomIconName = (typeof customFontAwesomeIcons)[keyof typeof customFontAwesomeIcons]["iconName"];

type CustomIconDefinition = {
  prefix: "fa-kit";
  iconName: CustomIconName;
};

export type KitIconDefinition = IconDefinition | CustomIconDefinition;

type Props = {
  icon: KitIconDefinition;
  className?: string;
};

export const FontAwesomeKitIcon = ({ icon, className }: Props) => {
  if (icon?.prefix === "fa-kit") {
    return <i className={`fa-kit fa-${icon.iconName}`} />;
  } else {
    return <FontAwesomeIcon icon={icon} className={className} />;
  }
};
